// extracted by mini-css-extract-plugin
module.exports = {"workspaceWrapper":"OpenerWorkspacePreview-styles-module--workspaceWrapper--2JNJW","panelist":"OpenerWorkspacePreview-styles-module--panelist--3PCAT"};